<template>
  <div>
    <section id="page-play" class="mdl-grid adv-content" style="display: block; background-color: white; margin-top:20px;">
      <h4 v-if="adventure" style="float:left;display:inline-block; text-align: left; text-overflow: ellipsis; width: calc(100% - 200px);">{{textTools.parseTitle(adventure.name, "Adventure")}} <small>by <router-link v-if="adventure.owner" to="/">{{adventure.owner.name}}</router-link></small></h4>
      <router-link v-if="!adventure.published" style="float: right;" :to="('/editor/'+adventureId+'/chapters')" class="mdl-button mdl-button--raised  mdl-button--colored mdl-js-button mdl-js-ripple-effect"><i class="material-icons">edit</i> Keep Editing</router-link>
      <div id="playerContainer" :class="usingObj&&'using-object'">
        <div v-if="usingObj" 
        :style="'top:-1000px; height: '+dimTools.dimFullToView(100,'player')+'px; '+
        'width: '+dimTools.dimFullToView(100,'player')+'px;' +
        'borderRadius: '+dimTools.dimFullToView(50,'player')+'px;' +
        'padding: '+dimTools.dimFullToView(30,'player')+'px;' +        
        'background-image: url('+usingObjBg+');'" id="usingObjDrag">
        </div>
        <div id="player" :style="'background-image: url('+getStageBg()+')'">
              <div v-if="!adventure.chapters || adventure.chapters.length<=0">
                <h2> NO CHAPTERS FOUND IN THIS ADVENTURE </h2>
              </div>
              <div id="playerTitles" :class="getShowTitles(showTitles)">
                <pre>{{titlesText}}</pre>
              </div>
              <div id="playerConsole" :class="getShowConsole(showConsole)">
                <pre>{{consoleText}}</pre>
              </div>
              <div v-for="(instance, instanceKey) in getInstances(instanceRefresh)" :name="instanceKey" 
              :style="'transform: translate('+dimTools.dimFullToView(instance.left,'player')+'px, '+dimTools.dimFullToView(instance.top,'player')+'px);'
                      +' height:'+dimTools.dimFullToView(instance.height,'player')+'px; width:'+dimTools.dimFullToView(instance.width,'player')+'px; background-image: url('+instance.bg+'); background-repeat: no-repeat; background-size: contain;  background-position: center; position: absolute;'"
                      @click="handleObject">
              </div>
              <div :style="'position: absolute; bottom: '+dimTools.dimFullToView(-180,'player')+'px; height: '+dimTools.dimFullToView(190,'player')+'px; '" id="inventory" :class="getShowInventory(showInventory)">
                <div :style="'height: '+dimTools.dimFullToView(160,'player')+'px; '+
                            'width: '+dimTools.dimFullToView(160,'player')+'px;' +
                            'padding: '+dimTools.dimFullToView(14,'player')+'px;' +
                            'border-radius: '+dimTools.dimFullToView(8,'player')+'px;' +
                            'margin: '+dimTools.dimFullToView(12,'player')+'px; margin-right: 0px;'" 
                            v-for="(object, objectKey) in save.inventory" :name="objectKey" @click="handleInventoryObject"
                :class="'mdl-cell inventory-object ' + getUsingObject(objectKey, usingObj)">
                    <div class="bg" :style="'background-image: url('+object.bg+')'"></div>
                    <div class="object-name" ><pre>{{object.name}}</pre></div>
                </div>                 
              </div>
        </div>
      </div>
      <div style="width:100%; height: 50px; text-align: center; margin-top: 10px;">
        <button style="margin-right: 6px;" @click="restartGame" class="mdl-button mdl-button--raised mdl-js-button mdl-js-ripple-effect">
          <i class="material-icons">autorenew</i> Restart Game</button>
        <button @click="toggleFullscreen" class="mdl-button mdl-button--raised mdl-js-button mdl-js-ripple-effect">
          <i class="material-icons">fullscreen</i> Fullscreen</button>
      </div>
      <span style="font-size: 0.8em; color: #999;" class="mdl-cell--hide-desktop">Swipe up/down to show/hide the inventory</span>
      <span style="font-size: 0.8em; color: #999;" class="mdl-cell--hide-phone mdl-cell--hide-tablet">Drag the mouse here to show the inventory</span>
     </section>
  </div>
</template>

<script>
  import Vue from 'vue'
  import Sortable from 'vue-sortable';
  import Breadcrumbs from './Breadcrumbs.vue';
  import DropzoneFirebase from './DropzoneFirebase.vue'
  import DimTools from './DimTools.js';
  import TextTools from './TextTools.js';

  Vue.use(Sortable)
  var sectionPlay

  var trackMouseForInventory = () => { 

    var touchstartY = 0;
    var touchendY = 0;

    var playerContainer = document.getElementById('playerContainer');
    playerContainer.addEventListener('touchstart', function(event) {
      touchstartY = event.changedTouches[0].screenY;
      }, false);
    playerContainer.addEventListener('touchend', function(event) {
      touchendY = event.changedTouches[0].screenY;
      handleGesture();
    }, false); 

    function handleGesture() {
      var swiped = 'swiped: ';
      var treshold = 20; //px
      if (touchendY + treshold < touchstartY) {
        //up
        sectionPlay.showInventory = true;
      }
      if (touchendY > touchstartY + treshold) {
        //down
        sectionPlay.showInventory = false;
      }
    }

    document.onmousemove = handleMouseMove;
      function handleMouseMove(event) {
        var dot, eventDoc, doc, body, pageX, pageY;

        event = event || window.event; // IE-ism

        // If pageX/Y aren't available and clientX/Y are,
        // calculate pageX/Y - logic taken from jQuery.
        // (This is to support old IE)
        if (event.pageX == null && event.clientX != null) {
            eventDoc = (event.target && event.target.ownerDocument) || document;
            doc = eventDoc.documentElement;
            body = eventDoc.body;

            event.pageX = event.clientX +
              (doc && doc.scrollLeft || body && body.scrollLeft || 0) -
              (doc && doc.clientLeft || body && body.clientLeft || 0);
            event.pageY = event.clientY +
              (doc && doc.scrollTop  || body && body.scrollTop  || 0) -
              (doc && doc.clientTop  || body && body.clientTop  || 0 );
        }
        var inventory = document.getElementById('inventory');
        if(inventory){
          var inventoryY = inventory.getBoundingClientRect().top;
          if(event.pageY>inventoryY) sectionPlay.showInventory = true;
          else sectionPlay.showInventory = false;
        }
        var usingObjDrag = document.getElementById('usingObjDrag');
        if(usingObjDrag){
          usingObjDrag.style.left = event.pageX + 'px';
          usingObjDrag.style.top = event.pageY + 'px';
        }
      }
  };

  var VueTouch = require('vue-touch')
  Vue.use(VueTouch, {name: 'v-touch'})

  export default{
    data: ()=>({
      FINISHING_TEXT: 'You finished this adventure',
      adventure: {},
      save: {},
      adventureLoaded: false,
      saveLoaded: false,
      adventureId: "",
      saveRef: {},
      savesInfoRef: {},
      advRef: {},
      user: false,
      dimTools: {},
      instanceRefresh: false,
      showInventory: false,
      consoleText: '',
      consoleTextTimeout: null,
      titlesText: '',
      titlesTextTimeout: null,
      showConsole: false,
      showTitles: false,
      usingObj: null,
      textTools: {}
    }),
    created() {
      sectionPlay = this;
      this.dimTools = DimTools;    
      window.addEventListener("resize", () => {sectionPlay.instanceRefresh = !sectionPlay.instanceRefresh;}, true); 
      this.adventureId = this.$route.params.adventure;
      this.user = window.firebase.auth().currentUser;
      if(this.user) this.startSetup();
      window.firebase.auth().onAuthStateChanged((user) => {
        sectionPlay.user = user;
        if(sectionPlay.user){
          sectionPlay.startSetup();
        }
      });
      this.textTools = TextTools;
    },
    mounted(){
      trackMouseForInventory();
      this.showInventory = true;
      // this.stage.instances = Object.assign({},this.stage.instances);
    },
    methods: {
      getShowInventory(showInventory){
        if(showInventory){
          return 'show-inventory'
        } 
        return '';
      },
      restartGame(){
        this.save = {};
        this.saveRef.set(this.save);
        this.savesInfoRef.set({});
        this.startSetup();
      },
      startSetup(){
        this.saveRef = window.firebase.database().ref('saves/'+this.user.uid+"/"+this.adventureId);
        this.savesInfoRef = window.firebase.database().ref('savesInfo/'+this.user.uid+"/"+this.adventureId);
        this.saveRef.on('value', function(snapshot) {
          sectionPlay.save = snapshot.val();
          if(!sectionPlay.save){
            sectionPlay.save = {'save': 'save'};
            sectionPlay.saveRef.set(sectionPlay.save);
          }
          sectionPlay.saveLoaded = true;
          if(sectionPlay.adventureLoaded){sectionPlay.continueSetup()}
        });
        this.advRef = window.firebase.database().ref('adventures/'+this.adventureId);
        this.advRef.on('value', function(snapshot) {
          sectionPlay.adventure = snapshot.val();
          sectionPlay.adventureLoaded = true;
          //save info stuff
          sectionPlay.savesInfoRef.child('lastPlayed').set(Date.now()-1000);
          sectionPlay.savesInfoRef.on('value', function(snapshot) {
            var saveInfo = snapshot.val();
            if(!saveInfo || !saveInfo.name && sectionPlay.adventure){
              sectionPlay.savesInfoRef.child('name').set(TextTools.parseTitle(sectionPlay.adventure.name, "Adventure"));
              sectionPlay.savesInfoRef.child('cover').set(sectionPlay.adventure.cover);
              sectionPlay.savesInfoRef.child('owner').set(sectionPlay.adventure.owner);
            }
          });
          //continue setup
          if(sectionPlay.saveLoaded){sectionPlay.continueSetup()}
        });
      },
      changeChapter(newChapterId){
        //CurrentChapter
        this.save.currentChapter = newChapterId;
        this.saveRef.child('currentChapter').set(newChapterId);
        //CurrentStage
        var stageId = this.adventure.chapters[this.save.currentChapter].initialStage;
        if(!stageId){
          stageId = Object.keys(this.adventure.chapters[this.save.currentChapter].stages)[0];
        }
        this.saveRef.child('currentStage').set(stageId);
        this.save.currentStage = stageId;
        this.save.stageInstances = {};
        var stages = this.adventure.chapters[this.save.currentChapter].stages;
        for(var stageKey in stages ){
          this.save.stageInstances[stageKey] = Object.assign({},stages[stageKey].instances);
        };
        this.saveRef.child('stageInstances').set(this.save.stageInstances);
        this.showTitlesText("Starting chapter: "+TextTools.parseTitle(this.adventure.chapters[this.save.currentChapter].name, "Chapter"), true);
        //CurrentTimeline
        this.save.currentTimeline = {'currentGroups': [], 'finishedActions':{}, 'inventory':[]};
        var parent=true;
        var index = -1;
        while(parent){
          index++;
          var parent = this.adventure.chapters[this.save.currentChapter].eventGroups[index].parent;
        }
        this.saveNewGroup(this.adventure.chapters[this.save.currentChapter].eventGroups[index].key);
        if(this.adventure.chapters[this.save.currentChapter].initialInventory){
          //load new inventory
        }
      },
      continueSetup(){
        if(this.save && this.adventure){
          if(!this.save.currentChapter){
            var chapterId = Object.keys(this.adventure.chapters)[0];
            this.saveRef.child('currentChapter').set(chapterId);
            this.save.currentChapter = chapterId;
            this.showTitlesText("Starting Adventure: "+TextTools.parseTitle(this.adventure.name, "Adventure")+" \n Chapter: "+TextTools.parseTitle(this.adventure.chapters[this.save.currentChapter].name, "Chapter"), true);
          }
          if(!this.save.currentStage){
            var stageId = this.adventure.chapters[this.save.currentChapter].initialStage;
            if(!stageId){
              stageId = Object.keys(this.adventure.chapters[this.save.currentChapter].stages)[0];
            }
            this.saveRef.child('currentStage').set(stageId);
            this.save.currentStage = stageId;
          }
          if(!this.save.stageInstances){
            this.save.stageInstances = {};
            var stages = this.adventure.chapters[this.save.currentChapter].stages;
            for(var stageKey in stages ){
              this.save.stageInstances[stageKey] = Object.assign({},stages[stageKey].instances);
            };
            this.saveRef.child('stageInstances').set(this.save.stageInstances);
          }
          if(!this.save.currentTimeline){
            this.save.currentTimeline = {'currentGroups': [], 'finishedActions':{}, 'inventory':[]};
            if(this.adventure.chapters[this.save.currentChapter].eventGroups && this.adventure.chapters[this.save.currentChapter].eventGroups.length>0){
              var parent=true;
              var index = -1;
              while(parent){
                index++;
                var parent = this.adventure.chapters[this.save.currentChapter].eventGroups[index].parent;
              }
              this.saveNewGroup(this.adventure.chapters[this.save.currentChapter].eventGroups[index].key);
            } 
          }
          else{
            if(!this.save.currentTimeline.currentGroups) this.save.currentTimeline.currentGroups=[];
            if(!this.save.currentTimeline.inventory) this.save.currentTimeline.inventory=[];
          }
          if(this.adventure.chapters[this.save.currentChapter].initialInventory){
            //load new inventory
          }
          if(!this.save.inventory){
            this.save.inventory = {};
          }
          if(this.save.finished){
            this.showTitlesText(this.FINISHING_TEXT);
          }
        }
      },
      removeGroup(groupId){
        var groupIndex = this.save.currentTimeline.currentGroups.indexOf(groupId);
        this.save.currentTimeline.currentGroups.splice(groupIndex, 1);
        this.saveRef.child('currentTimeline').set(this.save.currentTimeline);
      },
      saveNewGroup(groupId){
        this.saveNewGroupLocal(groupId);
        this.saveRef.child('currentTimeline').set(this.save.currentTimeline);
      },
      saveNewGroupLocal(groupId){
        this.save.currentTimeline.currentGroups.push(groupId);
        var group = this.getGroupById(groupId);
        var eventGroups = this.adventure.chapters[this.save.currentChapter].eventGroups;
        for(var eventIdx in group.events){
          var event = group.events[eventIdx];
          if(event.type==='group'){
            var children = false;
            for(var groupIdx in eventGroups){
              var groupAux = eventGroups[groupIdx];
              if(groupAux.parent===event.key){
                children = true;
                this.saveNewGroupLocal(groupAux.key);
                break;
              }
            }
            if(!children){
              //setting empty groups as finished by default
              if(!this.save.currentTimeline.finishedActions) this.save.currentTimeline.finishedActions= {};
              this.save.currentTimeline.finishedActions[event.key] = 'finished';
            }
          }
        }        
      },
      firebaseSaveActionsAndGroups(){
        this.saveRef.child('currentTimeline').set(this.save.currentTimeline);
      },
      saveNewAction(actionId, instanceId){ //an instance ID will be passed unless it's 2 objects in the inventory
        //save action
        if(!this.save.currentTimeline.finishedActions) this.save.currentTimeline.finishedActions= {};
        this.save.currentTimeline.finishedActions[actionId] = {'instanceId': instanceId};
        var group = this.getGroupByEventId(actionId);
          
        //check completeness of groups
        var unfinished = false;
        for(var actionIndex in group.events){
          var action = group.events[actionIndex];
          var actionInSave = this.findActionInSave(action.key);
          if(!actionInSave){
            unfinished = true;
          }
        }
        if(!unfinished){ //group is finished
          //we need to remove the group from current and add new one, if none after, then above (parent)
          var groupIndex = this.getGroupIndex(group.key);
          var eventGroups = this.adventure.chapters[this.save.currentChapter].eventGroups;
          var foundNext = false;
          for(var newGroupIndex = groupIndex + 1; newGroupIndex < eventGroups.length; newGroupIndex++){
            var newGroup = eventGroups[newGroupIndex];            
            if(newGroup.parent===group.parent){
              foundNext = true;
              this.removeGroup(group.key);
              this.saveNewGroup(newGroup.key);
              break
            }
          }
          if(!foundNext){ 
            //if parent -> complete parent, else chapter is finished
            if(group.parent){
              this.saveNewAction(group.parent, instanceId);
            }
            else{
              var chapterKeys = Object.keys(this.adventure.chapters);
              var currentChapterIndex = chapterKeys.indexOf(this.save.currentChapter);
              if(currentChapterIndex === (chapterKeys.length-1)){
                // finishGame();
                this.save.finished = true;
                this.saveRef.child('finished').set(true);
                this.savesInfoRef.child('finished').set(true);
                this.showTitlesText(this.FINISHING_TEXT);
              }
              else{
                this.changeChapter(chapterKeys[currentChapterIndex+1]);
              }
            }
          }
        }
        //update currentGroups in save
        
      },
      getGroupIndex(groupId){
        var eventGroups = this.adventure.chapters[this.save.currentChapter].eventGroups;
        for(var groupIndex in eventGroups){
          var group = eventGroups[groupIndex];
          if(group.key===groupId){
            return parseInt(groupIndex);
          }
        }
      },
      getGroupByEventId(eventId){
        for(var groupIndex in this.adventure.chapters[this.save.currentChapter].eventGroups){
          var group = this.adventure.chapters[this.save.currentChapter].eventGroups[groupIndex];
          var events = group.events;
          for(var eventIndex in events){
            if(events[eventIndex].key===eventId)
            return group;
          }
        }
      },
      getGroupById(groupId){
        var eventGroups = this.adventure.chapters[this.save.currentChapter].eventGroups;
        for(var groupIdx in eventGroups){
          var group = eventGroups[groupIdx];
          if(groupId === group.key){
            return group;
          }
        }
      },
      getStageBg(){
        if(this.save.currentStage && this.adventure.chapters)
        return this.adventure.chapters[this.save.currentChapter].stages[this.save.currentStage].bg;
      },
      getInstances(instanceRefresh){
        if(this.save.currentStage && this.adventure.chapters && this.save.stageInstances)
        return this.save.stageInstances[this.save.currentStage];
      },
      handleInventoryObject(event){
        var target = event.target;
        var objId = target.getAttribute('name');
        var object = this.adventure.chapters[this.save.currentChapter].objects[objId];
          
        if(this.usingObj){
          this.preAttemptAction(this.usingObj, objId, null, null);
        }
        else
        {
          this.showConsoleText('Use ' + object.name + ' with...');
          this.usingObj = objId;
          this.usingObjBg = object.bg;
        }
      },
      handleObject(event){
        var instanceId = event.target.getAttribute('name');
        var instance = this.save.stageInstances[this.save.currentStage][instanceId];
        if(instance.type==='path'){
          this.saveRef.child('currentStage').set(instance.path);
          this.save.currentStage = instance.path;
        }
        if(!instance.type || instance.type==='action'){
          var baseObj = instance.objId;
          var targetObj = undefined;
          if(this.usingObj){
            targetObj = baseObj;
            baseObj = this.usingObj;
          }
          this.preAttemptAction(baseObj, targetObj, instanceId, instance.text);
        }
      },
      preAttemptAction(baseObj, targetObj, instanceId, instanceText){
        if(!this.attemptAction(baseObj, targetObj, instanceId) && instanceText){
          this.showConsoleText(instanceText, true);
        }
        if(this.usingObj){
          this.usingObj = null;
          this.consoleTextTimeout = setTimeout(this.hideConsoleText, 3000);
        }
      },
      attemptAction(baseObj, targetObj, instanceId){
        for(var currentGroupIdx in this.save.currentTimeline.currentGroups){
          var currentGroupKey = this.save.currentTimeline.currentGroups[currentGroupIdx];
          var group = this.getGroupById(currentGroupKey);
          for(var eventIdx in group.events){
            var event = group.events[eventIdx];
            if(!event.type || event.type==='action'){
              if(event.targetObj === '') event.targetObj =undefined;
              if(event.baseObj===baseObj && event.targetObj===targetObj || event.baseObj===targetObj && event.targetObj===baseObj){
                //check possibly done already:
                var existing = this.findActionInSave(event.key);
                if(!existing){
                  if(this.performAction(event, instanceId)){
                    this.saveNewAction(event.key, instanceId);
                    this.firebaseSaveActionsAndGroups();
                    return true;
                  }
                }
              }
            }
          }
        }
        return false;
      },
      performAction(event, instanceId){ //where location is 'inventory' or 'stage', if stage, instanceId is given
        //REMOVING ORIGINAL OBJECTS, only for accepted combinations:
        // stage, inventory_stage, inventory_inventory
        var completed = false;
        var stageObj = {instance: {}, stageId: ''};
        if(instanceId && !event.targetObj){ //====>>>  //baseObj(remove_stage) - targetObj(none) /---/ pick up - or modify an obj on stage
          completed = true;
          stageObj = this.removeObjFromStage(instanceId);
        }
        if(instanceId && event.targetObj){// ====>>> //baseObj(remove_inventory) - targetObj(remove_stage) /---/ inventory - stage (use obj from inventory with inventory from stage)
          completed = true;
          stageObj = this.removeObjFromStage(instanceId);
          this.removeObjFromInventory(event.baseObj);
        }
        if(!instanceId && event.targetObj){ // ====>>> //baseObj(remove_inventory) - targetObj(remove_inventory)  	//use obj from inventory with obj from inventory)
          completed = true;
          this.removeObjFromInventory(event.baseObj);
          this.removeObjFromInventory(event.targetObj);
        }
        if(completed){
          if(event.resultStageObj){
            //for mind clarity I should probably create a new instance ID but for now I'm reusing the previous...
            var newInstance = Object.assign({}, stageObj.instance);
            newInstance.objId = event.resultStageObj;
            newInstance.bg = this.adventure.chapters[this.save.currentChapter].objects[event.resultStageObj].bg;
            newInstance.name = this.adventure.chapters[this.save.currentChapter].objects[event.resultStageObj].name;
            newInstance.text = null;
            this.save.stageInstances[stageObj.stageId][stageObj.instance.key] = newInstance;
            this.saveRef.child('stageInstances').set(this.save.stageInstances);
          }

          if(event.resultInventoryObj){
            this.showInventory = true;
            if(!this.save.inventory) this.save.inventory  = {};
            this.save.inventory[event.resultInventoryObj] = {
              'bg': this.adventure.chapters[this.save.currentChapter].objects[event.resultInventoryObj].bg,
              'name': this.adventure.chapters[this.save.currentChapter].objects[event.resultInventoryObj].name
            }
            this.saveRef.child('inventory').set(this.save.inventory);
          }
          this.instanceRefresh = !this.instanceRefresh;
          // this.showConsoleText(event.text, true);
          this.showConsoleText(TextTools.getActionText(event, this.adventure.chapters[this.save.currentChapter].objects), true);
          return true;
        }
        return false;
      },
      removeObjFromStage(instanceId){
        var stageIds = this.save.stageInstances;
        for(var stageId in stageIds){
          var stageInstances = this.save.stageInstances[stageId];
          for(var instanceIndex in stageInstances){
            if(instanceIndex === instanceId){
              var instance = Object.assign({}, stageInstances[instanceId]);
              instance.key = instanceId;
              stageInstances[instanceId] = null; //removed
              return {'instance': instance, 'stageId': stageId};
            }
          }
        }
      },
      removeObjFromInventory(objId){
        for(var objIndex in this.save.inventory){
          var obj = this.save.inventory[objIndex];
          if(obj.key === objId){
            delete(this.save.inventory[objIndex]);
          }
        }
      },
      findActionInSave(actionId){
        if(!this.save.currentTimeline.finishedActions)
        return;
        var finishedActions = Object.keys(this.save.currentTimeline.finishedActions);
        for(var actionIndex in finishedActions){
          var actionIdAux = finishedActions[actionIndex];
          if(actionIdAux===actionId){
            return actionIdAux;
          }
        }
      },
      getUsingObject(current, thisOne){
        if(current===thisOne) return 'using-object'
        return '';
      },
      getShowConsole(showConsole){
        if(showConsole) return ' show-console';
        return ''
      },
      getShowTitles(showTitles){
        if(showTitles) return ' show-titles';
        return ''
      },
      showTitlesText(text, temp){
        if(text && text.trim()!=''){
          if(this.titlesTextTimeout){
            clearTimeout(this.titlesTextTimeout);
          }
          if(temp){
            this.titlesTextTimeout = setTimeout(this.hideTitleText, 3000);
          }
          this.titlesText = text;
          this.showTitles = true;
        }
      },
      showConsoleText(text, temp){
        if(text && text.trim()!=''){
          this.showTitles = false;
          if(this.consoleTextTimeout){
            clearTimeout(this.consoleTextTimeout);
          }
          if(temp){
            this.consoleTextTimeout = setTimeout(this.hideConsoleText, 3000);
          }
          this.consoleText = text;
          this.showConsole = true;
        }
      },
      hideConsoleText(){
        this.showConsole = false;
      },
      hideTitleText(){
        this.showTitles = false;
      },
      toggleFullscreen(){
        var player = document.getElementById('playerContainer');
        if(player.requestFullscreen){
          player.requestFullscreen();
        }
        if(player.webkitRequestFullscreen){
          player.webkitRequestFullscreen();
        }
        if(player.mozRequestFullscreen){
          player.mozRequestFullscreen();
        }
          
      }
    }
  }

</script>


<style>

  #player{
    cursor: pointer;
    overflow: hidden; 
    position: relative; 
    width: 100%;
    max-height: 100%;
    padding: 28.125% 0 28.125% 0; 
    background-color: #aaa; 
    background-repeat: no-repeat; 
    background-size: contain; 
    background-position: center; 
  }

  #playerContainer{
    max-height: 100%;
    max-width: 100%;
  }

  #playerContainer.using-object *{
    cursor: crosshair !important;
  }


  #inventory{  
    width: 100%; 
    background-color: rgba(0, 0, 0, 0.3);
    transition: bottom 0.2s ease-in; 
  }
  #inventory:hover, #inventory.show-inventory{
    bottom: 0px !important;
  }

  #usingObjDrag{
    position: fixed;
    z-index: 300;
    pointer-events: none;
    background-color: rgba(200,200,200,0.2); 
    background-size: contain;  
    background-repeat: no-repeat;
    background-position: center;
  }
  
  .inventory-object{
    float: left; 
    background-color: rgba(200,200,200,0.5);
  }
  .inventory-object.using-object{
    outline: solid 3px #fff;
    background-color: rgba(200,200,200,1);
  }
  .inventory-object .bg{
    margin-top: -2.5%;
    position: relative;
    pointer-events: none;
    width: 100%;
    height: 60%;
    background-repeat: no-repeat; 
    background-size: contain;
    background-position: center;
  }
  .inventory-object .object-name{
    pointer-events: none;
    width: 100%;
    height: 40%;
    margin-top: 7.5%;
    display: flex;
    overflow: hidden;
  }

  .inventory-object .object-name pre{
    pointer-events: none;
    font-size: 0.9em; 
    line-height: 1.1em; 
    text-align: center;
    color: white;
    overflow: hidden;
    position: relative;
    white-space: normal;
    width: 100%;
    padding: 0;
    text-overflow: ellipsis;
    text-shadow: 0 0 5px rgba(0,0,0,1);
    margin: auto 0 auto 0;
  }
    
  
  #playerConsole{
    opacity: 0;
    position: absolute;
    width: 100%;
    top: 30%;
    max-height: 80%;
    line-height: 2em;
    vertical-align: middle;
    overflow-y: visible;
    pointer-events: none;
    padding: 20px; 
    text-align: center;
    margin-top: 20px;
    text-shadow: 0px 0px 5px rgba(0, 0, 0, 1);
    font-family: arial;
    font-weight: bold;
    color: white;
    font-size: 1.25em;
    transition: opacity 0.5s ease-in-out;
    z-index: 200;
    background-color: rgba(100,100,100,0.3);
  }
  #playerConsole.show-console{
    opacity: 1;
  }

  #playerTitles{
    opacity: 0;
    position: absolute;
    width: 100%;
    max-height: 100%;
    line-height: 1.5em;
    vertical-align: middle;
    overflow-y: visible;
    pointer-events: none;
    top: 0px;
    padding: 6% 20px 6% 20px; 
    text-align: center;
    text-shadow: 0px 0px 5px rgba(0, 0, 0, 1);
    font-family: arial;
    font-weight: bold;
    color: white;
    font-size: 1.5em;
    transition: opacity 0.5s ease-in-out;
    z-index: 201;
    background-color: rgba(0,0,0,0.3);
  }
  #playerTitles.show-titles{
    opacity: 1;
  }

  #player pre{
    white-space: pre-wrap;
  }

</style>



// WEBPACK FOOTER //
// SectionPlay.vue?6978686c